import * as React from "react";
import { DecorateEditorialHtml } from "src/components/flexComponents/Editorial/ContentUtilities";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";
import { UitkSpacing } from "uitk-react-spacing";

const CONTENT_ID_COUNT = 3;
export const CardComparisonAddedBenefitsSectionEditorial = (props: { items: EditorialModel[] }) => {
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [addedBenefitsIcon, addedBenefitsTitle, addedBenefitsContent] = React.useMemo(
    () => items.map((item) => <DecorateEditorialHtml key={item.id} text={item.text} />),
    []
  );

  return (
    <UitkSpacing
      padding={{ medium: { inline: "twelve" }, large: { inline: "unset", inlinestart: "twelve" } }}
      margin={{ medium: { inline: "twelve" }, large: { inline: "unset", inlinestart: "six" } }}
    >
      <UitkLayoutFlex space="three">
        <UitkLayoutFlexItem>
          <div>{addedBenefitsIcon}</div>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem>
          <div>
            <UitkText size={300} weight="medium">
              <div>{addedBenefitsTitle}</div>
            </UitkText>
            <UitkText size={200}>
              <div>{addedBenefitsContent}</div>
            </UitkText>
          </div>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    </UitkSpacing>
  );
};

export default CardComparisonAddedBenefitsSectionEditorial;
